import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchPostQuery } from '/src/api';
import { useForm, H2, Loader } from '/src/components';
import { useModalsContext, useStoreConfigContext } from '/src/providers';
import { cloudflareUseRecaptcha, cloudflareGetRecaptchaToken } from '/src/services';
import graphQLQueries from './graph-ql-queries';
import * as styles from './styles.scss';

const Subscribe = () => {
    const {
        storeConfig: {
            header_logo_src,
            logo_alt,
            cloudflare_captcha: {
                site_key: cloudflareSiteKey,
            },
        },
        translate,
    } = useStoreConfigContext();
    const { showModal, MODALS_TYPES } = useModalsContext();
    const { data, handleChange } = useForm({ email: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const { cloudflareResetRecaptcha } = cloudflareUseRecaptcha(cloudflareSiteKey, '#cf-turnstile-subscribe');

    const handleSubmit = e => {
        e.preventDefault();

        const recaptchaToken = cloudflareGetRecaptchaToken();

        if (!recaptchaToken) {
            showModal(MODALS_TYPES.ERROR, { errors: [{ message: 'Check recaptcha' }] });
        } else {
            setIsLoading(true);
            fetchPostQuery({
                query: graphQLQueries.subscribeEmailToNewsletter,
                variables: data,
                headers: { 'cf-turnstile-response': recaptchaToken }
            }).then(({ subscribeEmailToNewsletter: { status } }) => {
                setIsLoading(false);

                if (status === 'SUBSCRIBED') {
                    showModal(MODALS_TYPES.SUCCESS);
                    handleChange({
                        target: {
                            name: 'email',
                            value: '',
                            type: 'email',
                        }
                    });
                } else {
                    showModal(MODALS_TYPES.ERROR, { errors: [{ message: 'Something went wrong' }] })
                }

                setIsFocused(false);
                cloudflareResetRecaptcha();
            }).catch(errors => {
                setIsLoading(false);
                showModal(MODALS_TYPES.ERROR, { errors });
                cloudflareResetRecaptcha();
            })
        }
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <Link
                    className={styles.logo}
                    to="/"
                >
                    <img src={header_logo_src} alt={logo_alt} />
                </Link>
                <H2 className={styles.title}>
                    {translate('Join our mailing list for special offers & updates')}
                </H2>
                <Loader isLoading={isLoading}>
                    <form
                        onSubmit={handleSubmit}
                        onFocus={() => setIsFocused(true)}
                    >
                        <div className={styles.subscribe}>
                            <input
                                placeholder={translate('Enter your email')}
                                type="email"
                                name="email"
                                value={data.email}
                                onChange={handleChange}
                                aria-label="Subscribe"
                                autoComplete="off"
                            />
                            <button disabled={!data.email || isLoading}>
                                {translate('Subscribe')}
                            </button>
                        </div>
                        <div id="cf-turnstile-subscribe" className={isFocused ? styles.visible : styles.hidden} />
                    </form>
                </Loader>
                <div className={styles.follow}>
                    {translate('Follow us on social networks')}
                </div>
                <div className={styles.links}>
                    <a
                        className={styles.facebook}
                        href="https://www.facebook.com/buywholefoodsonline"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Facebook"
                    />
                    <a
                        className={styles.instagram}
                        href="https://www.instagram.com/buywholefoodsonline"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Instagram"
                    />
                    <a
                        className={styles.tiktok}
                        href="https://www.tiktok.com/@buywholefoodsonline"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="Tiktok"
                    />
                </div>
            </div>
        </div>
    )
};

export default Subscribe;
